// @flow

import Notifications from '../constants/Notifications';
import { price } from '../classes/Helpers';
import BaseComponent from './abstract/BaseComponent';

export default class CartTotal extends BaseComponent {
  total: HTMLElement;
  totalPrice: number;

  /**
   * Initialize the component
   *
   * @param pEl
   */
  bind(pEl: HTMLElement): void {
    super.bind(pEl);
    this.setProperties(['total']);
    this.totalPrice = +this.total.dataset.total;

    this.addListener(Notifications.CART_UPDATE_DATA, this.update);
    this.addListener(Notifications.COUPON_UPDATE_DATA, this.update);
  }

  /**
   * Update the prices
   */
  update(data: Object): void {
    if (Array.isArray(data)) {
      data = data[0];
    }
    this.total.innerText = price(data.summary.total);
  }
}
